import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { firstValueFrom } from 'rxjs';
import { UserInterface } from 'src/app/shared/interfaces/user.interface';
import { PaginatedResponseInterface } from 'src/app/shared/interfaces/paginated-reponse.interface';
import { DeviceConfigInterface } from '../../interfaces/device-config.interface';

@Injectable()
export class DeviceConfigService {
  private baseUrl = environment.BASE_PATH;

  constructor(
    private readonly http: HttpClient,
  ) { }

  async getUsersConfig(page: number = 0, size: number = 10): Promise<PaginatedResponseInterface<UserInterface>> {
    const url = `${this.baseUrl}/device-config?page=${page}&size=${size}`;
    const result$ = this.http.get<PaginatedResponseInterface<UserInterface>>(url);
    return await firstValueFrom(result$);
  }

  async createOne(deviceConfig: DeviceConfigInterface) {
    const url = `${this.baseUrl}/device-config`;
    return await firstValueFrom(this.http.post<DeviceConfigInterface>(url, deviceConfig));
  }

  async updateOne(deviceConfigId: number, deviceConfig: Partial<DeviceConfigInterface>) {
    const url = `${this.baseUrl}/device-config/${deviceConfigId}`;
    return await firstValueFrom(this.http.patch(url, deviceConfig));
  }

  async deleteOne(deviceConfigId: number) {
    const url = `${this.baseUrl}/device-config/${deviceConfigId}`;
    return await firstValueFrom(this.http.delete(url));
  }
}
